import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookmarks } from '../contexts/BookmarkContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bookmark } from 'lucide-react';
import { isJobViewed } from '../utils/viewedStore';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';

const HelperSavedJobsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { jobPostBookmarks, toggleJobPostBookmark } = useBookmarks();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">{t('helperSavedJobs.title', '已儲存的工作')}</CardTitle>
          <p className="text-sm text-muted-foreground">{t('helperSavedJobs.count', '共 {{count}} 個儲存的職位', { count: jobPostBookmarks.length })}</p>
        </CardHeader>
        <CardContent>
          {jobPostBookmarks.length === 0 ? (
            <div className="flex flex-col items-center py-16 text-center">
              <Bookmark className="mb-4 h-12 w-12 text-muted-foreground/40" />
              <p className="text-muted-foreground">{t('helperSavedJobs.noSaved', '尚未儲存任何工作')}</p>
              <Button className="mt-4" variant="outline" onClick={() => navigate('/job-postings')}>{t('helperSavedJobs.browseJobs', '瀏覽職位')}</Button>
            </div>
          ) : (
            <div className="space-y-3">
              {jobPostBookmarks.map((posting) => (
                <Card
                  key={posting.id}
                  className="cursor-pointer transition-shadow hover:shadow-md"
                  onClick={() => navigate(`/job-postings/${posting.id}/detail`)}
                >
                  <CardContent className="flex items-center gap-4 p-5">
                    <div className="min-w-0 flex-1">
                      <p className="font-semibold text-foreground">{posting.headline || posting.title}</p>
                      <p className="mt-0.5 text-xs text-muted-foreground">
                        {posting.location} · {posting.workType}
                      </p>
                    </div>
                    <div className="flex flex-col items-end gap-1 shrink-0">
                      {isJobViewed(posting.id) && (
                        <Badge variant="outline" className="text-[11px] text-muted-foreground">{t('common.viewed', '已瀏覽')}</Badge>
                      )}
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-8 w-8 p-0 text-muted-foreground hover:text-destructive"
                        onClick={(e) => { e.stopPropagation(); toggleJobPostBookmark(posting); }}
                      >
                        <Bookmark className="h-4 w-4 fill-current" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default HelperSavedJobsPage;
